import { Routes, Route, useLocation, Navigate } from "react-router-dom";
import {
  Navbar,
  Error404,
  ProfileEdit,
  Register,
  Signin,
} from "./routes/Routes";

import { useAuth } from "./hooks/GlobalProvider";
import Dashboard from "./routes/user/Dashboard";

import LogoLoader from "./components/LogoLoader/LogoLoader";
import AdminDashboard from "./routes/adminpannel/AdminDashboard";
import ReferalTree from "./routes/adminpannel/ReferalTree";
import Media from "./routes/adminpannel/Media";
import Reply from "./routes/adminpannel/Reply";

import Users from "./routes/adminpannel/Users/Users";
import AddBonus from "./routes/adminpannel/AddBonus.jsx"
import Report from "./routes/user/Report";
import New from "./routes/user/New";
import Farming from "./routes/user/Farming";
import Withdraw from "./routes/user/Withdraw";
import AllPayments from "./routes/adminpannel/AllPayments";
import AppSettings from "./routes/adminpannel/AppSettings";

const App = () => {
  const location = useLocation();
  const { user, loading } = useAuth();
  const hideNavbarRoutes = ["/", "/signup"]; // Removed "/Store/checkout"

  if (loading) {
    return <LogoLoader />;
  }

  return (
    <>
      {!hideNavbarRoutes.includes(location.pathname) && <Navbar />}
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<Signin />} />
        <Route path="/signup" element={<Register />} />

       
        <Route
          path="/dashboard"
          element={user ? <Dashboard /> : <Navigate to="/" />}
        />
        <Route
          path="/report"
          element={user ? <Report /> : <Navigate to="/" />}
        />
        <Route path="/new" element={user ? <New /> : <Navigate to="/" />} />
        <Route
          path="/farming"
          element={user ? <Farming /> : <Navigate to="/" />}
        />
        <Route
          path="/withdraw"
          element={user ? <Withdraw /> : <Navigate to="/" />}
        />

        <Route
          path="/admin-dashboard"
          element={user ? <AdminDashboard /> : <Navigate to="/" />}
        />
        <Route
          path="/referal-tree"
          element={user ? <ReferalTree /> : <Navigate to="/" />}
        />
        <Route
          path="/admin-dashboard/media"
          element={user ? <Media /> : <Navigate to="/" />}
        />
        <Route
          path="/admin-dashboard/add-bonus"
          element={user ? <AddBonus /> : <Navigate to="/" />}
        />

        <Route
          path="/admin-dashboard/reply"
          element={user ? <Reply /> : <Navigate to="/" />}
        />
        <Route
          path="/admin-dashboard/all-payments"
          element={user ? <AllPayments /> : <Navigate to="/" />}
        />
        <Route
          path="/admin-dashboard/app-settings"
          element={user ? <AppSettings /> : <Navigate to="/" />}
        />

        <Route path="/users" element={user ? <Users /> : <Navigate to="/" />} />

        <Route path="/settings" element={<ProfileEdit />} />
        <Route path="/*" element={<Error404 />} />
      </Routes>
    </>
  );
};

export default App;
